import { jsx as l } from "react/jsx-runtime";
import { c as o } from "../clsx-OuTLNxxd.js";
import { T as d, h as m, g as _, a as T, d as i, c as g, e as p } from "../Table-FdtKvdZ4.js";
import { T as C } from "../TableScrollContainer-uSu2bdoS.js";
import '../StatsTable.css';const w = "_wrapper_1bbjg_53", y = "_table_1bbjg_75", h = "_tableHead_1bbjg_83", j = "_tableColumn_1bbjg_91", u = "_tableBody_1bbjg_105", N = "_tableRow_1bbjg_109", S = "_tableCell_1bbjg_112", B = "_tableFooter_1bbjg_122", b = {
  wrapper: w,
  table: y,
  tableHead: h,
  tableColumn: j,
  tableBody: u,
  tableRow: N,
  tableCell: S,
  tableFooter: B
}, c = ({
  caption: e,
  cellWidth: t = 60,
  children: a,
  className: n,
  maxRows: s,
  ...r
}) => /* @__PURE__ */ l(
  C,
  {
    caption: e,
    cellWidth: t,
    className: o(b.wrapper, n),
    "data-cxy-name": "stats-table",
    maxRows: s,
    ...r,
    children: /* @__PURE__ */ l(d, { className: b.table, "data-testid": "stats-table", children: a })
  }
), F = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(m, { className: o(b.tableRow, t), size: "s", ...a, children: e }), H = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...s
}) => /* @__PURE__ */ l(
  i,
  {
    className: o(b.tableColumn, t),
    "data-justify": a,
    "data-pinned": n,
    "data-type": "heading",
    justifyContent: a,
    ...s,
    children: e
  }
), R = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...s
}) => /* @__PURE__ */ l(
  g,
  {
    className: o(b.tableCell, t),
    "data-highlight": !!s.highlight,
    "data-justify": a,
    "data-pinned": n,
    justifyContent: a,
    ...s,
    children: e
  }
), f = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(p, { ...a, className: o(b.tableFooter, t), children: e }), x = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(_, { ...a, className: o(b.tableHead, t), children: e }), z = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(T, { className: o(b.tableBody, t), ...a, children: e });
c.Row = F;
c.Head = x;
c.Body = z;
c.Column = H;
c.Cell = R;
c.Footer = f;
export {
  c as StatsTable
};
